















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import { IAccountCertificateInfoInput } from '@/modules/AccountCertificate/interfaces/account-certificate-form'

@Component({
  components: {
    AppTextSearch,
    AppTextField,
    AppSelector,
    AppDatePicker,
    AppTextarea
  }
})
export default class AccountCertificateFormInfo extends Vue {
  @Prop({ type: Object as () => IAccountCertificateInfoInput }) value!: IAccountCertificateInfoInput

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
